import { User, Calendar, MapPin, Wrench, ClipboardCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const steps = [
  {
    icon: User,
    title: 'Book',
    subtitle: 'Get a quote & book your service',
    description: 'Get a quote & book your service'
  },
  {
    icon: Calendar,
    title: 'Schedule',
    subtitle: 'Confirm a time that works for you',
    description: 'Confirm a time that works for you'
  },
  {
    icon: MapPin,
    title: 'Arrival',
    subtitle: 'We come to your location',
    description: 'We come to your location'
  },
  {
    icon: Wrench,
    title: 'Service',
    subtitle: 'Professional service on-site',
    description: 'Professional service on-site'
  },
  {
    icon: ClipboardCheck,
    title: 'Complete',
    subtitle: 'Report and payment processed',
    description: 'Report and payment processed'
  }
];

export const HowItWorksSection = () => {
  const navigate = useNavigate();
  return (
    <section 
      id="how-it-works" 
      className="py-12 lg:py-24 relative overflow-hidden bg-gradient-to-br from-primary/5 via-background to-muted/10 mobile-section-spacing"
    >
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 hero-pattern opacity-20"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="section-header">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-primary to-primary-hover rounded-2xl mb-8 shadow-[var(--shadow-glow)]">
            <Wrench className="w-10 h-10 text-white" />
          </div>
          <h2 className="section-title">
            How Our Mobile Service Works
          </h2>
          <p className="section-subtitle">
            Simple, professional, and convenient. Get your car serviced in 5 easy steps without leaving your location.
          </p>
          <div className="section-divider" />
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 max-w-7xl mx-auto mobile-grid-fix">
          {steps.map((step, index) => (
            <div key={index} className="text-center relative px-2">
              <div className="relative mb-6 z-10">
                <div className="section-icon mx-auto relative transition-transform duration-300">
                  <step.icon className="w-8 h-8 lg:w-10 lg:h-10 text-white" />
                </div>
              </div>
              
              <div className="text-center space-y-3 relative z-10">
                <h3 className="text-lg lg:text-2xl font-bold text-foreground mb-2 lg:mb-3 transition-colors duration-300 leading-tight px-1">
                  {step.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed font-medium px-2 text-sm lg:text-base">
                  {step.description}
                </p>
              </div>
              
              {/* Enhanced connector arrow */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-20 -right-6 z-20">
                  <div className="w-12 h-12 bg-card/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg">
                    <svg className="w-6 h-6 text-primary" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="mt-12 lg:mt-20 text-center space-y-6 lg:space-y-8">
          <div className="bg-gradient-to-r from-primary/20 to-primary/10 rounded-2xl lg:rounded-3xl p-6 lg:p-12 shadow-lg">
            <h3 className="text-2xl lg:text-3xl xl:text-4xl font-bold text-foreground mb-4 lg:mb-6">
              Ready to Experience the Convenience?
            </h3>
            <p className="text-lg lg:text-xl text-muted-foreground mb-6 lg:mb-8 max-w-3xl mx-auto px-2">
              Book your mobile mechanic service in under 60 seconds. Professional, reliable, and convenient.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 lg:gap-6 justify-center">
              <button 
                onClick={() => navigate('/book-now')}
                className="btn-premium text-base lg:text-lg py-3 lg:py-4 px-6 lg:px-10"
              >
                BOOK YOUR SERVICE NOW
              </button>
              <button 
                onClick={() => navigate('/get-quote')}
                className="btn-outline-premium text-base lg:text-lg py-3 lg:py-4 px-6 lg:px-10"
              >
                Get Free Quote First
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};